"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaCalendarInstance = _interopRequireDefault(require("./AaCalendarInstance.component"));

var _AaCalendar = require("../AaCalendar.model");

var _AaCalendar2 = require("../AaCalendar.utilities");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaHelpers = require("../../../../utils/AaHelpers");

var _uiUtils = require("@airasia/ui-utils");

var _EnvironmentUrl = _interopRequireDefault(require("../../../../config/environment/EnvironmentUrl"));

var _reactRedux = require("react-redux");

var _stateVariables = _interopRequireDefault(require("../../../../config/stateVariables"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var weekDaysNames = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
var weekDaysKeys = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];

var AaCalendarWidget = function AaCalendarWidget(props) {
  var startDate = new Date();
  var maxDays = props.controls.maxDays;

  var maxDate = _AaCalendar2.AaCalendarUtilities.addDaysToDate(startDate, maxDays);

  var monthsDifference = _AaCalendar2.AaCalendarUtilities.monthsDifference(startDate, maxDate);

  var win = _reactNativeWeb.Dimensions.get('window');

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      departPrice = _useState2[0],
      setDepartPrice = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      pricesOneWay = _useState4[0],
      setPricesOneWay = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      pricesReturn = _useState6[0],
      setPricesReturn = _useState6[1];

  var scrollViewheight = 0;

  var diff = _AaCalendar2.AaCalendarUtilities.monthsDifference(startDate, new Date(props.dates.checkinDate));

  var _useState7 = (0, _react.useState)(new Date(props.dates.checkinDate)),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      checkinCalendarDate = _useState8[0],
      setCheckinCalendarDate = _useState8[1];

  var _useState9 = (0, _react.useState)(_AaCalendar2.AaCalendarUtilities.addMonthToDate(checkinCalendarDate, 1)),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      checkoutCalendarDate = _useState10[0],
      setCheckoutCalendarDate = _useState10[1];

  var _useState11 = (0, _react.useState)(diff > 0),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      enablePrevButton = _useState12[0],
      setEnablePrevButton = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      enableNextButton = _useState14[0],
      setEnableNextButton = _useState14[1];

  (0, _react.useEffect)(function () {
    if (props.controls.resetData) {
      setCheckinCalendarDate(new Date());
      setCheckoutCalendarDate(_AaCalendar2.AaCalendarUtilities.addMonthToDate(new Date(), 1));
      setEnablePrevButton(false);
      setEnableNextButton(true);
    }
  }, [props.controls.resetData]);
  (0, _react.useEffect)(function () {
    if (!props.widgetData) {
      return;
    }

    if (!props.widgetData.origin || !props.widgetData.destination) {
      return;
    }

    if (props.lfcOneWay && props.lfcOneWay.userData && !props.lfcOneWay.isFetching && !props.lfcOneWay.isError) {
      var key = "".concat(props.widgetData.origin.StationCode).concat(props.widgetData.destination.StationCode, "|").concat(props.controls.currencyDetails.currencyCode.toUpperCase());
      setPricesOneWay(props.lfcOneWay.userData.data[key]);

      var formattedDate = _AaCalendar2.AaCalendarUtilities.datePayloadFormat(new Date(data.checkinDate.year, data.checkinDate.month, data.checkinDate.date));

      if (props.lfcOneWay.userData.data && props.lfcOneWay.userData.data[key] && props.lfcOneWay.userData.data[key][formattedDate]) {
        setDepartPrice(props.lfcOneWay.userData.data[key][formattedDate]);
      }
    }

    if (props.lfcReturn && props.lfcReturn.userData && !props.lfcReturn.isFetching && !props.lfcReturn.isError) {
      var _key = "".concat(props.widgetData.destination.StationCode).concat(props.widgetData.origin.StationCode, "|").concat(props.controls.currencyDetails.currencyCode.toUpperCase());

      setPricesReturn(props.lfcReturn.userData.data[_key]);
    }
  }, [props.lfcOneWay, props.lfcReturn]); // if(props.controls.selectionType === CALENDAR_SELECTION_TYPE.TWO && !props.dates.checkoutDate){
  //     toggleDateSelection(TOGGLE_DATE_SELECTION.RETURN);
  // }

  var getDepartureDate = function getDepartureDate(date, price) {
    props.controls.toggleDateSelection(_AaCalendar.TOGGLE_DATE_SELECTION.RETURN);
    props.controls.onDepartChange(date);
    setDepartPrice(price);
  };

  var getReturnDate = function getReturnDate(date) {
    if (!date) {
      props.controls.toggleDateSelection(_AaCalendar.TOGGLE_DATE_SELECTION.RETURN);
    } else {
      props.controls.toggleDateSelection(_AaCalendar.TOGGLE_DATE_SELECTION.DEPART);
    }

    props.controls.onReturnChange(date);
  };

  var onBackCalendar = function onBackCalendar() {
    if (!enablePrevButton) {
      return;
    }

    setCheckinCalendarDate(_AaCalendar2.AaCalendarUtilities.subtractMonthToDate(checkinCalendarDate, 1));
    setCheckoutCalendarDate(_AaCalendar2.AaCalendarUtilities.subtractMonthToDate(checkoutCalendarDate, 1));
    if (!enableNextButton) setEnableNextButton(true);

    if (_AaCalendar2.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate(_AaCalendar2.AaCalendarUtilities.subtractMonthToDate(checkinCalendarDate, 1), startDate)) {
      setEnablePrevButton(false);
    } else {
      setEnablePrevButton(true);
    }
  };

  var onNextCalendar = function onNextCalendar() {
    if (!enableNextButton) {
      return;
    }

    var nextCalendarDate = _AaCalendar2.AaCalendarUtilities.addMonthToDate(checkoutCalendarDate, 1);

    setCheckinCalendarDate(_AaCalendar2.AaCalendarUtilities.addMonthToDate(checkinCalendarDate, 1));
    setCheckoutCalendarDate(nextCalendarDate);
    if (!enablePrevButton) setEnablePrevButton(true);

    if (_AaCalendar2.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(nextCalendarDate, maxDate) || nextCalendarDate.getMonth() === maxDate.getMonth() && nextCalendarDate.getFullYear() === maxDate.getFullYear()) {
      setEnableNextButton(false);
    } else {
      setEnableNextButton(true);
    }
  };

  var departCalendarInstanceConfig = {
    controls: {
      onDepartSelected: getDepartureDate,
      onReturnSelected: getReturnDate,
      onPrevButtonClicked: onBackCalendar,
      showDaysDisplay: true
    }
  };
  var returnCalendarInstanceConfig = {
    controls: {
      onDepartSelected: getDepartureDate,
      onReturnSelected: getReturnDate,
      onNextButtonClicked: onNextCalendar,
      showDaysDisplay: true
    }
  };
  var mobileCalendarInstanceConfig = {
    controls: {
      onDepartSelected: getDepartureDate,
      onReturnSelected: getReturnDate
    }
  };
  var data = {
    checkinDate: {
      year: props.dates.checkinDate ? props.dates.checkinDate.getFullYear() : null,
      month: props.dates.checkinDate ? props.dates.checkinDate.getMonth() : null,
      date: props.dates.checkinDate ? props.dates.checkinDate.getDate() : null
    },
    checkoutDate: {
      year: props.dates.checkoutDate ? props.dates.checkoutDate.getFullYear() : null,
      month: props.dates.checkoutDate ? props.dates.checkoutDate.getMonth() : null,
      date: props.dates.checkoutDate ? props.dates.checkoutDate.getDate() : null
    }
  };
  var dateToManipulate = startDate;
  var monthsYearArray = [{
    month: dateToManipulate.getMonth(),
    year: dateToManipulate.getFullYear()
  }];

  for (var i = 1; i <= monthsDifference; i++) {
    dateToManipulate = _AaCalendar2.AaCalendarUtilities.addMonthToDate(dateToManipulate, 1);
    var monthYear = {
      month: dateToManipulate.getMonth(),
      year: dateToManipulate.getFullYear()
    };
    monthsYearArray.push(monthYear);
  }

  var headerHeight = (_reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === 'ios') && props.controls.layout.isTablet ? 70 : 132;
  var footerHeight = 72;
  var widgetModalHeaderHeight = props.controls.viewType === 2 ? 56 : 0;
  var weekHeight = 15;
  var extra = _reactNativeWeb.Platform.OS !== 'web' ? 15 : 0;

  var getHeaderHeight = function getHeaderHeight() {
    if ((_reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === 'ios') && props.controls.layout.isTablet) {
      return 70;
    } else if (_reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === 'ios') {
      return 130;
    }

    return 70;
  };

  scrollViewheight = win.height - getHeaderHeight() - footerHeight - weekHeight - widgetModalHeaderHeight - extra;
  (0, _react.useEffect)(function () {
    callOneWay();

    if (props.controls.selectionType === _AaCalendar.CALENDAR_SELECTION_TYPE.TWO) {
      callReturn();
    }
  }, [props.widgetData]);

  var callOneWay = function callOneWay() {
    if (!props.widgetData) {
      return;
    }

    if (!props.widgetData.origin || !props.widgetData.destination) {
      return;
    }

    if (!props.controls.currencyDetails || !props.controls.currencyDetails.currencyCode) {
      return;
    }

    var member = props.controls.isLogin || _AaCalendar.LFC_MEMBER.ANONYMOUS,
        role = props.controls.layout.isMobile || _reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === 'ios' ? _AaCalendar.LFC_ROLE.MOBILE : _AaCalendar.LFC_ROLE.DESKTOP,
        months = 16,
        stateKey = _AaCalendar.LFC_STATE_KEY.ONEWAY,
        date = _AaCalendar2.AaCalendarUtilities.datePayloadFormat(new Date());

    setLFCprice(member, role, props.controls.currencyDetails.currencyCode.toUpperCase(), props.widgetData.origin.StationCode, props.widgetData.destination.StationCode, date, 1, months, stateKey);
  };

  var callReturn = function callReturn() {
    if (!props.widgetData) {
      return;
    }

    if (!props.widgetData.origin || !props.widgetData.destination) {
      return;
    }

    if (!props.controls.currencyDetails || !props.controls.currencyDetails.currencyCode) {
      return;
    }

    var member = props.controls.isLogin || _AaCalendar.LFC_MEMBER.ANONYMOUS,
        role = props.controls.layout.isMobile || _reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === 'ios' ? _AaCalendar.LFC_ROLE.MOBILE : _AaCalendar.LFC_ROLE.DESKTOP,
        months = 16,
        stateKey = _AaCalendar.LFC_STATE_KEY.RETURN,
        date = _AaCalendar2.AaCalendarUtilities.datePayloadFormat(new Date());

    setLFCprice(member, role, props.controls.currencyDetails.currencyCode.toUpperCase(), props.widgetData.destination.StationCode, props.widgetData.origin.StationCode, date, 2, months, stateKey);
  };

  var setLFCprice = function setLFCprice(member, role, currency, origin, destination, checkinDate, triptype) {
    var monthsToDisplay = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 16;
    var stateKey = arguments.length > 8 ? arguments[8] : undefined;

    if (member === undefined || member === null || role === undefined || role === null || !currency) {
      return;
    }

    if (!origin || !destination) {
      return;
    }

    if (!checkinDate || !triptype) {
      return;
    }

    if (props.lfcOneWay) {
      if (props.lfcOneWay.isFetching) {
        return;
      }
    }

    if (props.lfcReturn && props.controls.selectionType === _AaCalendar.CALENDAR_SELECTION_TYPE.TWO) {
      if (props.lfcReturn.isFetching) {
        return;
      }
    }

    var token = props.widgetData.token;
    var header = {
      'X-Custom-Flag': '1',
      'Authorization': "Bearer " + token
    };
    var endpoint = null;

    if (_reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === 'ios') {
      endpoint = _EnvironmentUrl["default"][props.controls.environment].LFC_PRICE_ENDPOINT.MOBILE;
    } else {
      endpoint = _EnvironmentUrl["default"][props.controls.environment].LFC_PRICE_ENDPOINT.WEB;
    }

    props.make_async_get_call((0, _AaHelpers.format)(endpoint, [member, role, currency.toUpperCase(), origin.toUpperCase(), destination.toUpperCase(), checkinDate, triptype, monthsToDisplay]), header, stateKey, false, null);
  };

  (0, _react.useEffect)(function () {
    getCurrencyDataFormat(props.controls.locale);
  }, [props.controls.locale]);

  var getCurrencyDataFormat = function getCurrencyDataFormat(locale) {
    if (!locale) {
      locale = 'en-gb';
    }

    props.make_async_get_call((0, _AaHelpers.format)(_EnvironmentUrl["default"][props.controls.environment].DATA_FORMAT.CURRENCY, [locale]), {}, _AaCalendar.DATA_FORMAT_STATE_KEY.CURRENCY, false, null);
  };

  (0, _react.useEffect)(function () {
    if (!props.dataFormatCurrency) {
      return;
    }

    if (!props.dataFormatCurrency.userData || !props.dataFormatCurrency.userData.data) {
      return;
    }

    _AaCalendar2.AaCalendarUtilities.setCurrencyFormat(props.dataFormatCurrency.userData.data);
  }, [props.dataFormatCurrency]);
  (0, _react.useEffect)(function () {
    if (!props.dataFormatDate) {
      return;
    }

    if (!props.dataFormatDate.userData || !props.dataFormatDate.userData.data) {
      return;
    }

    if (!props.dataFormatDate.userData.data.letterDaysTranslation) {
      return;
    }

    var day = props.dataFormatDate.userData.data.letterDaysTranslation;
    weekDaysNames = [day.mon, day.tue, day.wed, day.thu, day.fri, day.sat, day.sun];
  }, [props.dataFormatDate]);
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      backgroundColor: "#fff"
    }
  }, !props.controls.viewType || props.controls.viewType === _AaCalendar.CALENDAR_VIEW_TYPE.DESKTOP ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.calendar
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.calendarInstanceContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.calendarInstance
  }, /*#__PURE__*/_react["default"].createElement(_AaCalendarInstance["default"], {
    controls: _objectSpread(_objectSpread({}, departCalendarInstanceConfig.controls), {}, {
      calendarIndex: 0,
      showPrevButton: true,
      year: checkinCalendarDate.getFullYear(),
      month: checkinCalendarDate.getMonth(),
      enablePrevButton: enablePrevButton,
      selectForCheckin: props.controls.selectForCheckin,
      selectForCheckout: props.controls.selectForCheckout,
      maxDate: maxDate,
      maxDays: maxDays,
      selectionType: props.controls.selectionType,
      layout: props.controls.layout,
      resetData: props.controls.resetData,
      dataFormatCurrency: props.dataFormatCurrency,
      dataFormatDate: props.dataFormatDate,
      currencyDetails: props.controls.currencyDetails,
      departPrice: departPrice,
      maxDisplayedDate: checkoutCalendarDate
    }),
    lfcPrices: {
      oneway: pricesOneWay,
      "return": pricesReturn
    },
    data: data
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.divider
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.calendarInstance
  }, /*#__PURE__*/_react["default"].createElement(_AaCalendarInstance["default"], {
    controls: _objectSpread(_objectSpread({}, returnCalendarInstanceConfig.controls), {}, {
      calendarIndex: 1,
      showNextButton: true,
      year: checkoutCalendarDate.getFullYear(),
      month: checkoutCalendarDate.getMonth(),
      enableNextButton: enableNextButton,
      selectForCheckin: props.controls.selectForCheckin,
      selectForCheckout: props.controls.selectForCheckout,
      maxDate: maxDate,
      selectionType: props.controls.selectionType,
      layout: props.controls.layout,
      resetData: props.controls.resetData,
      dataFormatCurrency: props.dataFormatCurrency,
      dataFormatDate: props.dataFormatDate,
      currencyDetails: props.controls.currencyDetails,
      departPrice: departPrice,
      maxDisplayedDate: checkoutCalendarDate
    }),
    lfcPrices: {
      oneway: pricesOneWay,
      "return": pricesReturn
    },
    data: data
  })))) : null, props.controls.viewType === _AaCalendar.CALENDAR_VIEW_TYPE.MOBILE ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [styles.calendarMobile, {
      height: scrollViewheight
    }]
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.weekContainer
  }, weekDaysNames.map(function (day, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      key: "".concat(props.controls.type, "-").concat(weekDaysKeys[index]),
      style: styles.calendarItem
    }, day);
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.FlatList, {
    keyExtractor: function keyExtractor(item, index) {
      return "Instance-".concat(item.year.toString(), "-").concat(item.month.toString());
    },
    data: monthsYearArray,
    renderItem: function renderItem(_ref) {
      var item = _ref.item;
      return /*#__PURE__*/_react["default"].createElement(_AaCalendarInstance["default"], {
        controls: _objectSpread(_objectSpread({}, mobileCalendarInstanceConfig.controls), {}, {
          calendarIndex: 0,
          showPrevButton: false,
          showNextButton: false,
          year: item.year.toString(),
          month: item.month.toString(),
          selectForCheckin: props.controls.selectForCheckin,
          selectForCheckout: props.controls.selectForCheckout,
          maxDate: maxDate,
          maxDays: maxDays,
          dataFormatCurrency: props.dataFormatCurrency,
          dataFormatDate: props.dataFormatDate,
          currencyDetails: props.controls.currencyDetails,
          departPrice: departPrice,
          maxDisplayedDate: maxDate
        }),
        lfcPrices: {
          oneway: pricesOneWay,
          "return": pricesReturn
        },
        data: data
      });
    },
    removeClippedSubviews: true,
    initialNumToRender: 2,
    maxToRenderPerBatch: 1,
    updateCellsBatchingPeriod: 100,
    windowSize: 3
  })) : null);
};

var styles = _crossPlatformComponents.StyleSheet.create({
  calendar: {// width: 800
  },
  calendarInstanceContainer: {
    flexDirection: 'row'
  },
  calendarInstance: {
    flex: 1,
    paddingHorizontal: 10
  },
  divider: {
    backgroundColor: '#dfe0e2',
    width: 1,
    marginTop: 57
  },
  //mobile
  calendarMobile: {
    flexDirection: 'column'
  },
  weekContainer: {
    flexDirection: 'row',
    paddingVertical: 10,
    borderBottomColor: '#bfc5cf',
    borderBottomWidth: 1,
    height: 42
  },
  calendarItem: {
    flex: 1,
    textAlign: 'center',
    paddingBottom: 3,
    width: 55,
    color: 'black',
    android: {
      color: '#75767A',
      // fontWeight: '500',
      // fontSize: 14,
      //   fontWeight: '300',
      // fontSize: 12,
      fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM
    },
    ios: {
      color: '#75767A',
      // fontWeight: '500',
      // fontSize: 14,
      //  fontWeight: '300',
      // fontSize: 12,
      fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM
    }
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    data: state[_stateVariables["default"].updated_state],
    lfcOneWay: state.asyncAction[_AaCalendar.LFC_STATE_KEY.ONEWAY],
    lfcReturn: state.asyncAction[_AaCalendar.LFC_STATE_KEY.RETURN],
    dataFormatCurrency: state.asyncAction[_AaCalendar.DATA_FORMAT_STATE_KEY.CURRENCY],
    dataFormatDate: state.asyncAction[_AaCalendar.DATA_FORMAT_STATE_KEY.DATE]
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  make_async_get_call: _uiUtils.make_async_get_call
})(AaCalendarWidget);

exports["default"] = _default;